import * as types from '../mutation-types'
import * as actionTypes from '../action-types'
import server from '../server'
import axios from 'axios/index'
import moment from 'moment-es6'
import { changeInterventionVisibility } from './interactionsModule'
import { getTextColor } from '../../HelperMethods'
import colors from 'vuetify/es5/util/colors'
import { GET_STUDENT_GRAPH_INTERACTIONS } from '../getter-types'
import graphRequestTypes from '../graphRequestTypes'
export const ratingMap = {
  'NONE': 'N',
  'VERY_LOW': 'V',
  'LOW': 'L',
  'PARTIAL': 'P',
  'GOOD': 'G',
  'HIGH': 'H'
}
const ratingIndexMap = [
  'N', 'V', 'L', 'P', 'G', 'H'
]

function getStudentEngagementSummary () {
  return {
    HIGH: {},
    GOOD: {},
    PARTIAL: {},
    LOW: {},
    VERY_LOW: {},
    NONE: {}
  }
}

const state = {
  student: {},
  studentEngagement: {},
  studentEngagementSummary: getStudentEngagementSummary(),
  studentProfile: {},
  studentExemptions: [],
  courseAverage: {},
  courseTop: {},
  interventions: [],
  calendarInfo: [],
  interventionsLoading: false,
  graphInteractions: [],
  showGraphInterventions: true,
  showGraphAlerts: true,
  showGraphCourseChange: true,
  averageAttendance: -1,
  averageCourseAttendance: -1,
  graphDataLoaded: false,
  functions: {
    grade: 'GRADE',
    student: 'STUDENT',
    studentEngagement: 'STUENGTAB',
    studentInteractions: 'STUINTTAB',
    trend: 'TREND'
  },
  options: {
    enable: {
      alertIndicator: 'ENBALTIND',
      alertCheckbox: 'ENBALTCB',
      interactionsTab: 'ENBINTTAB',
      interventionIndicator: 'ENBINTIND',
      exemptionIndicator: 'ENBEXMIND',
      interventionCheckbox: 'ENBINTCB',
      exemptionCheckbox: 'ENBEXMCB',
      adminTop25: 'ENBADMNT25',
      staffTop25: 'ENBSTAFT25',
      studentTop25: 'ENBSTUDT25'
    },
    disable: {
      gradeBubble: 'DISGRDEBUB',
      attendanceBubble: 'DISATTBUB',
      trendBubble: 'DISTNDBUB',
      engagementBubble: 'DISENGBUB',
      engagementOverallButton: 'DISECOB'
    }
  }
}

const mutations = {
  [types.SET_STUDENT] (state, student) {
    state.student = student
  },
  [types.RESET_STUDENT] (state) {
    state.student = {}
    state.studentEngagement = {}
    state.interventions = []
    state.averageAttendance = -1
    state.averageCourseAttendance = -1
  },
  [types.SET_STUDENT_ENGAGEMENT] (state, studentEngagement) {
    state.studentEngagement = studentEngagement
  },
  [types.SET_STUDENT_PROFILE] (state, studentProfile) {
    state.studentProfile = studentProfile
  },
  [types.SET_STUDENT_COURSE_AVERAGE] (state, courseAverage) {
    state.courseAverage = courseAverage
  },
  [types.SET_STUDENT_COURSE_TOP] (state, courseTop) {
    state.courseTop = courseTop
  },
  [types.SET_STUDENT_EXEMPTIONS] (state, exemptions) {
    state.studentExemptions = exemptions
  },
  [types.SET_INTERVENTION_SHOW_STATE] (state, id) {
    const intervention = state.interventions.find(int => int.id === id)
    intervention.isOpen = !intervention.isOpen
  },
  [types.SET_STUDENT_INTERVENTIONS] (state, res) {
    state.interventions = []
    state.interventions.push(...res.map(flattenIntervention))
  },
  [types.REPLACE_STUDENT_INTERVENTIONS] (state, res) {
    state.interventions = res.map(flattenIntervention)
  },
  [types.HANDLE_UPDATE_INTERVENTION_RESPONSE] (state, res) {
    let tempItem = {
      interactionType: 'INTERVENTION',
      intervention: res
    }
    const updatedIntervention = flattenIntervention(tempItem)
    state.interventions.forEach((interaction, idx) => {
      if (!interaction.intervention) {
        return
      }
      // If it matches both int id and student id
      if (interaction.intervention.id === updatedIntervention.intervention.id &&
        interaction.intervention.student.id === updatedIntervention.intervention.student.id) {
        // Go through each object parameter and change it
        Object.keys(interaction.intervention)
          .filter(key => key !== 'isOpen')
          .filter(key => key !== 'reset')
          .filter(key => key !== 'isHidden')
          .forEach(key => {
            interaction.intervention[key] = updatedIntervention.intervention[key]
          })
        // If it matches only the int id remove it from this student's list
      } else if (interaction.intervention.id === updatedIntervention.intervention.id) {
        state.interventions.splice(idx, 1)
      }
    })
  },
  [types.ADD_COMMENT_TO_INTERVENTION] (state, res) {
    state.interventions.forEach((intervention) => {
      if (intervention.intervention && intervention.intervention.id === res.interventionId) {
        // Comments made on a NEW intervention over a minute after it was
        // created will change the status to IN_PROGRESS
        if ((intervention.status === 'NEW') &&
          (res.commentDate > intervention.creationDate + 60000)) {
          intervention.status = 'IN_PROGRESS'
        }
        intervention.intervention.interventionComments.push(res)
      }
    })
  },
  [types.RESET_AND_SCROLL_INTERVENTION] (state, id) {
    state.interventions.forEach((intervention) => {
      if (intervention.intervention && intervention.intervention.id === id) {
        intervention.reset = !intervention.reset
      }
    })
  },
  [types.STUDENT_INTERVENTIONS_OPEN_BY_ID] (state, id) {
    state.interventions.forEach((intervention) => {
      if (intervention.id === id) {
        intervention.isOpen = true
      }
    })
  },
  [types.HIDE_INTERVENTION_BY_ID] (state, id) {
    changeInterventionVisibility(state.interventions.find(interaction => interaction.intervention && interaction.intervention.id === id), true)
  },
  [types.SHOW_INTERVENTION_BY_ID] (state, id) {
    changeInterventionVisibility(state.interventions.find(interaction => interaction.intervention && interaction.intervention.id === id), false)
  },
  [types.UPDATED_INTERVENTION] (state, intervention) {
    let index = state.interventions.findIndex(elem => elem.intervention && elem.intervention.id === intervention.id)
    if (index >= 0) {
      state.interventions[index].intervention = intervention
    }
  },
  [types.UPDATE_EXEMPTION_MUTATION] (state, data) {
    const exemption = state.interventions.find(interaction => interaction.exemption && interaction.exemption.id === data.id)
    if (exemption) {
      exemption.exemption.startDate = data.startDate
      exemption.exemption.endDate = data.endDate
      exemption.exemption.exemptionReason = data.exemptionReason
    }
  },
  [types.DELETE_EXEMPTION_MUTATION] (state, id) {
    state.interventions = state.interventions.filter(interaction => !(interaction.exemption && interaction.exemption.id === id))
  },
  [types.SET_STUDENT_CALENDAR_DATA] (state, data) {
    Object.freeze(data)
    data.forEach((item) => Object.freeze(item))
    state.calendarInfo = data
  },
  [types.SET_STUDENT_INTERVENTIONS_LOADING] (state, loading) {
    state.interventionsLoading = loading
  },
  [types.SET_GRAPH_INTERVENTIONS] (state, value) {
    state.showGraphInterventions = value
  },
  [types.SET_GRAPH_ALERTS] (state, value) {
    state.showGraphAlerts = value
  },
  [types.SET_GRAPH_COURSE_CHANGE] (state, value) {
    state.showGraphCourseChange = value
  },
  [types.SET_STUDENT_AVERAGE_ATTENDANCE] (state, average) {
    state.averageAttendance = average
  },
  [types.SET_STUDENT_COURSE_AVERAGE_ATTENDANCE] (state, average) {
    state.averageCourseAttendance = average
  },
  [types.SET_STUDENT_GRAPH_INTERACTIONS] (state, data) {
    const finalGraphInteractions = []
    // Converting map to array
    for (let key in data) {
      if (!data.hasOwnProperty(key)) continue
      const graphInteraction = {
        date: key
      }
      graphInteraction.list = data[key].map((interaction) => { return {type: interaction} })
      finalGraphInteractions.push(graphInteraction)
    }
    state.graphInteractions = finalGraphInteractions
  },
  [types.SET_STUDENT_ENGAGEMENT_SUMMARY] (state, data) {
    const studentEngagementSummary = getStudentEngagementSummary()
    const length = data.length
    data.forEach(engagement => {
      studentEngagementSummary[engagement.engagementRating].count = studentEngagementSummary[engagement.engagementRating].count + 1 || 1
    })

    Object.keys(studentEngagementSummary).forEach(key => {
      studentEngagementSummary[key].percentage = Number((studentEngagementSummary[key].count * 100 / length).toFixed(2)) || 0
    })

    state.studentEngagementSummary = studentEngagementSummary
  },
  [types.SET_STUDENT_GRAPH_DATA_LOADED] (state, value) {
    state.graphDataLoaded = value
  },
  [types.SOFT_RESET_STUDENT_ENGAGEMENT] (state) {
    state.studentEngagement = []
    state.graphInteractions = []
    state.studentExemptions = []
  },
  [types.SOFT_RESET_STUDENT_INTERVENTION] (state) {
    state.interventions = []
  }
}

const fetchStudentInteractions = function (rootState, studentId, actionData) {
  return axios({
    url: `${rootState.config.baseUrl}:${rootState.config.port}/core/interaction/get/student/${studentId}`,
    method: 'get',
    headers: {
      'Authorization': rootState.profile.loginToken
    },
    actionData
  })
}

let graphRequests = {
  [graphRequestTypes.FETCH_STUDENT_GRAPH_INTERACTIONS] ({rootState, commit}, {studentId, startDate, endDate, actionData}) {
    return new Promise((resolve, reject) => {
      server.getReplayable(`/core/student/${studentId}/event/${startDate}/${endDate}`, actionData)
       .then(res => {
         commit(types.SET_STUDENT_GRAPH_INTERACTIONS, res.data)
         resolve(res)
       })
       .catch(err => {
         console.error(err)
         reject(err)
       })
    })
  },
  [graphRequestTypes.GET_STUDENT_ENGAGEMENT] (context, {studentId, startDate, endDate, actionData}) {
    return new Promise((resolve, reject) => {
      context.commit(types.SOFT_RESET_STUDENT_ENGAGEMENT)
      server.getReplayable(`/core/student/${studentId}/get/engagement_score/${startDate}/${endDate}`, actionData).then(response => {
        context.commit(types.SET_STUDENT_ENGAGEMENT_SUMMARY, response.data)
        let data = {
          rating: response.data.map(entry => {
            return {x: entry.engagementScoreDate, y: ratingMap[entry.engagementRating]}
          }),
          dateLabels: response.data.map(entry => entry.engagementScoreDate)
        }
        context.commit(types.SET_STUDENT_ENGAGEMENT, data)
        resolve(data)
      })
    })
  },
  [graphRequestTypes.GET_STUDENT_CUMULATIVE_ENGAGEMENT] (context, {studentId, startDate, endDate, actionData}) {
    return new Promise((resolve, reject) => {
      server.getReplayable(`/core/student/${studentId}/get/engagement_score/${startDate}/${endDate}`, actionData).then(response => {
        let data = {
          rating: response.data.map(entry => {
            return {x: entry.engagementScoreDate, y: entry.cumulativeScore}
          }),
          dateLabels: response.data.map(entry => entry.engagementScoreDate)
        }
        context.commit(types.SET_STUDENT_ENGAGEMENT, data)
        resolve(data)
      })
    })
  },
  [graphRequestTypes.GET_STUDENT_COURSE_AVERAGE] (context, {cohortId, startDate, endDate, actionData}) {
    return new Promise((resolve, reject) => {
      server.getReplayable(`/core/engagement/course_average/${cohortId}/${startDate}/${endDate}`, actionData).then(response => {
        let ratings = {
          rating: response.data.map(entry => {
            return {x: entry.scoreDate, y: ratingIndexMap[entry.rating]}
          })
        }
        context.commit(types.SET_STUDENT_COURSE_AVERAGE, ratings)
        resolve(ratings)
      })
    })
  },
  [graphRequestTypes.GET_STUDENT_CUMULATIVE_COURSE_AVERAGE] (context, {cohortId, startDate, endDate, actionData}) {
    return new Promise((resolve, reject) => {
      server.getReplayable(`/core/engagement/cumulative_course_average/${cohortId}/${startDate}/${endDate}`, actionData).then(response => {
        let ratings = {
          rating: response.data.map(entry => {
            return {x: entry.scoreDate, y: entry.rating}
          })
        }
        context.commit(types.SET_STUDENT_COURSE_AVERAGE, ratings)
        resolve(ratings)
      })
    })
  },
  [graphRequestTypes.GET_STUDENT_COURSE_TOP] (context, {cohortId, startDate, endDate, actionData}) {
    return new Promise((resolve, reject) => {
      server.getReplayable(`/core/engagement/course_top_quartile/${cohortId}/${startDate}/${endDate}`, actionData).then(response => {
        let ratings = {
          rating: response.data.map(entry => {
            return {x: entry.scoreDate, y: ratingIndexMap[entry.rating]}
          })
        }
        context.commit(types.SET_STUDENT_COURSE_TOP, ratings)
        resolve(ratings)
      })
    })
  },
  [graphRequestTypes.GET_STUDENT_CUMULATIVE_COURSE_TOP] (context, {cohortId, startDate, endDate, actionData}) {
    return new Promise((resolve, reject) => {
      server.getReplayable(`/core/engagement/cumulative_course_top_quartile/${cohortId}/${startDate}/${endDate}`, actionData).then(response => {
        let ratings = {
          rating: response.data.map(entry => {
            return {x: entry.scoreDate, y: entry.rating}
          })
        }
        context.commit(types.SET_STUDENT_COURSE_TOP, ratings)
        resolve(ratings)
      })
    })
  },
  [graphRequestTypes.GET_STUDENT_EXEMPTIONS] ({commit}, {studentId, actionData}) {
    return new Promise((resolve, reject) => {
      server.getReplayable(`/core/exemption/${studentId}`, actionData).then(response => {
        let data = []
        response.data.forEach(range => {
          let endDate = (range.endDate ? moment(range.endDate) : moment()).add(1, 'days').subtract(1, 'seconds').valueOf()
          data.push({startDate: moment(range.startDate).valueOf(), endDate})
        })
        commit(types.SET_STUDENT_EXEMPTIONS, data)
        resolve(data)
      })
    })
  }
}

const actions = {
  [actionTypes.GET_STUDENT] (context, studentId) {
    const url = `/core/student/${studentId}`
    const actionData = { action: actionTypes.GET_STUDENT, data: studentId }
    return server.getReplayable(url, actionData).then(student => {
      context.commit(types.SET_STUDENT, student.data)
    })
  },
  [actionTypes.GET_STUDENT_PROFILE] (context, studentId) {
    context.commit(types.SET_STUDENT_PROFILE, {})
    const url = `/core/student/${studentId}/get/profile`
    const actionData = { action: actionTypes.GET_STUDENT_PROFILE, data: studentId }
    return server.getReplayable(url, actionData).then(studentProfile => {
      context.commit(types.SET_STUDENT_PROFILE, studentProfile.data)
    })
  },
  [actionTypes.REPLACE_STUDENT_INTERACTIONS] ({rootState, commit}, studentId) {
    commit(types.SET_STUDENT_INTERVENTIONS_LOADING, true)
    const actionData = { action: actionTypes.REPLACE_STUDENT_INTERACTIONS, data: studentId }
    fetchStudentInteractions(rootState, studentId, actionData)
      .then((res) => {
        commit(types.REPLACE_STUDENT_INTERVENTIONS, res.data)
        commit(types.SET_STUDENT_INTERVENTIONS_LOADING, false)
      })
      .catch((err) => {
        console.error(err)
        commit(types.SET_STUDENT_INTERVENTIONS_LOADING, false)
      })
  },
  [actionTypes.GET_STUDENT_INTERACTIONS] ({rootState, commit}, studentId) {
    commit(types.SET_STUDENT_INTERVENTIONS_LOADING, true)
    commit(types.SOFT_RESET_STUDENT_INTERVENTION)
    const actionData = { action: actionTypes.GET_STUDENT_INTERACTIONS, data: studentId }
    fetchStudentInteractions(rootState, studentId, actionData)
      .then((res) => {
        commit(types.SET_STUDENT_INTERVENTIONS, res.data)
        commit(types.SET_STUDENT_INTERVENTIONS_LOADING, false)
      })
      .catch((err) => {
        console.error(err)
        commit(types.SET_STUDENT_INTERVENTIONS_LOADING, false)
      })
  },
  [actionTypes.GET_STUDENT_CALENDAR_INFORMATION] ({rootState, commit}, studentId) {
    const actionData = { action: actionTypes.GET_STUDENT_CALENDAR_INFORMATION, data: studentId }
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/student/${studentId}/get/engagement_score`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData
    }).then((res) => {
      commit(types.SET_STUDENT_CALENDAR_DATA, res.data)
    }).catch((err) => {
      console.error(err)
    })
  },
  [actionTypes.GET_STUDENT_AVERAGE_ATTENDANCE] ({rootState, commit}, studentId) {
    const url = `/core/student/${studentId}/attendance_percentage`
    const actionData = { action: actionTypes.GET_STUDENT_AVERAGE_ATTENDANCE, data: studentId }
    server.getReplayable(url, actionData).then(response => {
      commit(types.SET_STUDENT_AVERAGE_ATTENDANCE, response.data)
    })
  },
  [actionTypes.GET_STUDENT_COURSE_AVERAGE_ATTENDANCE] ({rootState, commit}, cohortId) {
    const url = `/core/course/${cohortId}/attendance_percentage`
    const actionData = { action: actionTypes.GET_STUDENT_COURSE_AVERAGE_ATTENDANCE, data: cohortId }
    server.getReplayable(url, actionData).then(response => {
      commit(types.SET_STUDENT_COURSE_AVERAGE_ATTENDANCE, response.data)
    })
  },
  [actionTypes.GET_STUDENT_GRAPH_DATA] ({dispatch, commit, context, rootState}, {data, graphs}) {
    commit(types.SET_STUDENT_GRAPH_DATA_LOADED, false)
    const actionData = { action: actionTypes.GET_STUDENT_GRAPH_DATA, data: {data, graphs} }
    const graphData = Object.assign({}, data, {actionData})
    let promises = []
    const state = {dispatch, commit, context, rootState}
    graphs.forEach((action) => {
      promises.push(graphRequests[action](state, graphData))
    })
    Promise.all(promises).then(() => {
      commit(types.SET_STUDENT_GRAPH_DATA_LOADED, true)
    })
  },
  [actionTypes.POST_STUDENT_HELP_POPUP] ({rootState}) {
    const actionData = {action: actionTypes.POST_STUDENT_HELP_POPUP}
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/help/popup/`,
      method: 'post',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData
    }).catch(err => {
      console.error(err)
      console.log(`Failed to post help pop up audit`)
    })
  },
  [actionTypes.POST_STUDENT_HELP_POPUP_ARTICLE] ({rootState}, article) {
    const actionData = {action: actionTypes.POST_STUDENT_HELP_POPUP_ARTICLE}
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/help/popup/${article}`,
      method: 'post',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData
    }).catch(err => {
      console.error(err)
      console.log(`Failed to post help pop up article audit`)
    })
  }
}

const getters = {
  GET_STUDENT_VISIBLE_INTERACTIONS: (state) => {
    return state.interventions.filter(i => !i.isHidden)
  },
  GET_STUDENT_CALENDAR_INFO_BY_DATE: (state) => {
    if (state.calendarInfo.length > 0) {
      let previousRating = state.calendarInfo[0].engagementRating
      let startDate = state.calendarInfo[0].engagementScoreDate
      let endDate = state.calendarInfo[0].engagementScoreDate
      const ratings = []

      state.calendarInfo.forEach((rating) => {
        if (previousRating === rating.engagementRating) {
          endDate = rating.engagementScoreDate
          return
        }

        const attribute = getRatingAttribute(previousRating, startDate, endDate)

        previousRating = rating.engagementRating
        startDate = rating.engagementScoreDate
        endDate = rating.engagementScoreDate

        ratings.push(attribute)
      })

      ratings.push(getRatingAttribute(previousRating, startDate, endDate))
      return ratings
    }
  },
  GET_STUDENT_COURSE_DESCRIPTION: (state) => {
    return state.student.course ? state.student.course.courseDescription : ''
  },
  GET_STUDENT_AGE: (state) => {
    return state.student.dateOfBirth ? moment().diff(moment(state.student.dateOfBirth), 'years') : null
  },
  [GET_STUDENT_GRAPH_INTERACTIONS] (state) {
    const interactions = []
    state.graphInteractions.map((date) => {
      let mutable = Object.assign({}, date)
      mutable.list =
        date.list
          .filter(interaction => interaction.type !== 'INTERVENTION' || state.showGraphInterventions)
          .filter(interaction => interaction.type !== 'ALERT' || state.showGraphAlerts)
          .filter(interaction => interaction.type !== 'COURSE_CHANGE' || state.showGraphCourseChange)
      interactions.push(mutable)
    })
    return interactions
  }
}

const flattenIntervention = (interaction) => {
  if (interaction.interactionType === 'INTERVENTION') {
    interaction.isOpen = false
    interaction.reset = false
    interaction.isHidden = false
    return interaction
  } else {
    return interaction
  }
}

const ratingColors = {
  N: colors.grey.base,
  V: colors.red.base,
  L: colors.orange.base,
  P: colors.purple.lighten2,
  G: colors.lightBlue.base,
  H: colors.green.base
}

const getRatingAttribute = (rating, startDate, endDate) => {
  const backgroundColor = ratingColors[ratingMap[rating]]
  const attribute = {
    contentStyle: {
      color: getTextColor(backgroundColor)
    },
    highlight: {
      backgroundColor: backgroundColor
    },
    popover: {
      label: ratingMap[rating]
    }
  }

  if (startDate === endDate) {
    attribute.dates = moment(startDate).toDate()
  } else {
    attribute.dates = {
      start: moment(startDate).toDate(),
      end: moment(endDate).toDate()
    }
  }
  return attribute
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/studentModule.js